import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import { NbTrack } from '../../pages/music/ordered-playback/ordered-playback.component';
export class Track {
  name?: string;
  artist?: string;
  url: string;
  cover?: string;
  tracks?: NbTrack[];
}

@Injectable()
export class PlayerService {
  private playlist: Track[] = [];
  private current: number;
  private playerListUpdate = new BehaviorSubject({});
  playerListUpdate$: Observable<any> = this.playerListUpdate.asObservable();

  setPlayerList(lists: Track[]) {
    this.playlist = lists;
    this.current = -1;
    this.playerListUpdate.next({});
  }

  random(): Track {
    this.current = Math.floor(Math.random() * this.playlist.length);
    return this.playlist[this.current];
  }

  next(): Track {
    return this.getNextTrack();
  }

  prev() {
    return this.getPrevTrack();
  }

  private getNextTrack(): Track {
    if (this.current === this.playlist.length - 1) {
      this.current = 0;
    } else {
      this.current++;
    }

    return this.playlist[this.current];
  }

  private getPrevTrack(): Track {
    if (this.current === 0) {
      this.current = this.playlist.length - 1;
    } else {
      this.current--;
    }

    return this.playlist[this.current];
  }
}



// WEBPACK FOOTER //
// /srv/staging/FitRadioAdmin2/src/app/@core/data/player.service.ts